import React from 'react'
import Hero from './Hero/Hero'
import FeaturePowerhouse from './FeaturePowerhouse/FeaturePowerhouse'
import SocialSamples from './SocialSamples/SocialSamples'
import ComparisonSection from './ComparisonSection/ComparisonSection'
import Pricing from './Pricing/Pricing'
import Feedback from './Feedback/Feedback'
import OtherServices from '../OtherServices/OtherServices'
import Navbar from './Navbar/Navbar' // Import Navbar
import Footer from './Footer/Footer' // Import Footer

const Home = () => {
  return (
    <div>
      <Navbar />
      
      <div id="home">
        <Hero/>
      </div>

      <div id="about">
        <FeaturePowerhouse/>
      </div>

      <div id="samples">
        <SocialSamples/>
      </div>

      <div id="why">
        <ComparisonSection/>
      </div>

      <div id="pricing">
        <Pricing/>
      </div>

      <div id="feedback">
        <Feedback/>
      </div>

      <div id="services">
        <OtherServices/>
      </div>

     
    </div>
  )
}

export default Home